import { render, staticRenderFns } from "./PersonSearch.vue?vue&type=template&id=26078e34&scoped=true&"
import script from "./PersonSearch.vue?vue&type=script&lang=ts&"
export * from "./PersonSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26078e34",
  null
  
)

export default component.exports